// extracted by mini-css-extract-plugin
export default {"sharedFooter":"Footer_sharedFooter__qyXeq","sharedFooterShrunk":"Footer_sharedFooterShrunk__WnHLR"};